// externals
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

// types
import type { EditProductTaxableProps } from '../../types';

const EditProductTaxable = ({ productProps }: { productProps: EditProductTaxableProps }) => {
    const taxableText = productProps.isProductTaxable ? 'Yes' : 'No';

    return (
        <Box display="flex" flexDirection="column" alignItems="baseline">
            <Box marginBottom="1rem">
                <Typography variant="label-md" color="base.color.gray.600" data-testid={'product-taxable'}>
                    Taxable
                </Typography>
            </Box>
            <Box marginBottom="1rem">
                <Typography variant="body-md" data-testid={'product-taxable-value'}>
                    {taxableText}
                </Typography>
            </Box>
        </Box>
    );
};

export default EditProductTaxable;
